var map = {
	"./assets/images/Amsterdam-light/image1.jpg": 64,
	"./assets/images/Blue-light/image1.jpg": 65,
	"./assets/images/Bucharest-light/image1.jpg": 66,
	"./assets/images/Japon-light/image1.jpg": 67,
	"./assets/images/Jose-Light/image1.jpg": 68,
	"./assets/images/Larue-light/image1.jpg": 69,
	"./assets/images/Lesgarsfontduspor/image1.jpg": 70,
	"./assets/images/Orlando-light/image1.jpg": 71,
	"./assets/images/Woodi-light/image1.jpg": 72,
	"./assets/images/turkey-light/image1.jpg": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;